// Shell chrome strings (auto-merged by lib/i18n.ts).
export const en = {
  'app.cmdk.goto': 'Go to {label}',
  'app.user_menu.open': 'Open account menu',
  'app.user_menu.account': 'Account',
  'app.user_menu.settings': 'Settings',
  'app.user_menu.security': 'Security & 2FA',
  'app.user_menu.logout': 'Log out',
  'app.shell.close_nav': 'Close navigation',
  'app.shell.toggle_sidebar': 'Toggle sidebar',
  'app.shell.primary_nav': 'Primary',
}

export const zhTW = {
  'app.cmdk.goto': '前往{label}',
  'app.user_menu.open': '開啟帳號選單',
  'app.user_menu.account': '帳號',
  'app.user_menu.settings': '設定',
  'app.user_menu.security': '安全性與雙重驗證',
  'app.user_menu.logout': '登出',
  'app.shell.close_nav': '關閉導覽',
  'app.shell.toggle_sidebar': '切換側邊欄',
  'app.shell.primary_nav': '主要',
}
